import * as React from "react";
import { EntityReference, NewFieldType } from "./models";
import styled from "styled-components";
import ReactDropdown, { DropdownOption } from "../common/ReactDropdown";
import { SingleValue } from "react-select";

export interface NewFieldProps {
  type: NewFieldType;
  defaultValue: unknown | null;
  value: unknown | null;
  typeData: unknown;
  onChange: (newValue: unknown | null) => void;
}

const NewFieldWrapper = styled.div``;

const NewField = ({
  type,
  defaultValue,
  value,
  typeData,
  onChange,
}: NewFieldProps): JSX.Element => {
  function renderField(): JSX.Element {
    switch (type) {
      case "companyType": {
        return (
          <CompanyType
            type={type}
            defaultValue={defaultValue}
            value={value}
            typeData={typeData}
            onChange={onChange}
          />
        );
      }
    }
  }

  return <NewFieldWrapper>{renderField()}</NewFieldWrapper>;
};

const CompanyType = ({
  type,
  defaultValue,
  value,
  typeData,
  onChange,
}: NewFieldProps) => {
  const options = React.useMemo(() => {
    return (typeData as EntityReference[]).map((option) => ({
      value: (option.id as number).toString(),
      label: option.name,
    }));
  }, [typeData]);

  function internalOnChange(newValue: SingleValue<DropdownOption>) {
    let actualValue: string | number | undefined = newValue?.value;

    if (actualValue != null) {
      actualValue = parseInt(actualValue);
    }

    onChange && onChange(actualValue ?? null);
  }

  return (
    <ReactDropdown
      options={options}
      isClearable={true}
      initialValue={`${defaultValue}`}
      placeholder="Välj företagstyp"
      slim={true}
      onChange={internalOnChange}
      value={(value as number)?.toString()}
    />
  );
};

export default NewField;
